import { useContext } from 'react';
import TimerContext from '../../TimerContext/Timercontext';
import { useGetSales } from '../../Dashboard/api';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const TokenSale = ({homepagedata,buy}) => { 
    const {t} = useTranslation();

    const currencyList = homepagedata?.acceptable_currencies.split(', ');

    const midpoint = Math.ceil(currencyList?.length / 2);

    const firstHalf = currencyList?.slice(0, midpoint).join(', ');
    const secondHalf = currencyList?.slice(midpoint).join(', ');
    const { days, hours, minutes, seconds, visible} = useContext(TimerContext)

    const {data : getSalesProgress } = useGetSales()

    const totalPurchased = getSalesProgress?.data?.totalPurchased;
    const totalPreSupply = getSalesProgress?.data?.totalPreSupply;

    const availableTokens = totalPreSupply - totalPurchased

    const salePercentage = totalPreSupply > 0 ? (availableTokens / totalPreSupply) * 100 : 0


    return (            
        <section className="TknslSec"   data-aos="zoom-in" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-delay="100">
            <div className="container">
                <div className="TknSlBg">
                    <div className='row'>
                        <div className='col-lg-3'>
                            <div className="MxBnsAvl text-right">
                                <div className="MxBnsAvlDts">
                                    <h6>{t('Max Bonus Available')}</h6>
                                    <h5>{homepagedata?.max_bonus_available}%</h5>
                                </div>
                                <div className="MxBnsAvlDts">
                                    <h6>{t('Exchange Rate')}</h6>
                                    <h5>1 KKOG=${homepagedata?.exchange_rate}</h5>
                                </div>
                                <div className="MxBnsAvlDts">
                                    <h6>{t('Acceptable Currency')}</h6>
                                    <h5 className='pb-0'>{firstHalf}</h5>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className="TknSlInr">
                                <h3>{t('Token Sale')}</h3>
                              { visible ? 
                                <div className='BnrTmr'>
                                    <div className="BnrTmrDv">
                                        <div className='Ldv'>
                                            <h4>{days}</h4>
                                            <h6>{t('Days')}</h6>
                                        </div>
                                        <div className='Rdv'>:</div>
                                        <div className='Ldv'>
                                            <h4>{hours}</h4>
                                            <h6>{t('Hours')}</h6>
                                        </div>
                                        <div className='Rdv'>:</div>
                                        <div className='Ldv'>
                                            <h4>{minutes}</h4>
                                            <h6>{t('Minutes')}</h6>
                                        </div>
                                        <div className='Rdv'>:</div>
                                        <div className='Ldv'>
                                            <h4>{seconds}</h4>
                                            <h6>{t('Seconds')}</h6>
                                        </div>
                                    </div>
                                </div>
                                :""}
                                <div className="TknSlPrgBr">
                                    <div className="TknslPrgBrTp">
                                        <span>{t('Sale Raised')}</span>
                                        <span>{t('Limit')}</span>
                                    </div>
                                    <div className="progress">
                                        <div className="progress-bar" style={{width: `${salePercentage}%`}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{parseFloat((salePercentage)?.toFixed(2)) || 0}%</div>
                                    </div>
                                    <div className="TknSlPrgBrLmt">
                                        <span>{getSalesProgress?.data?.totalPurchased} KKOG</span>
                                        <span>{getSalesProgress?.data?.totalPreSupply} KKOG</span>
                                    </div>
                                </div>
                                <button className="btn CmnBtn mx-auto h-46" onClick={buy}>{t('Buy KKOG COIN')}<img src={require('../../../assets/images/cart.gif')} className='ml-3' alt='' width="23px" /></button>
                                <div className='BnrSpnSrDv'>
                                    <p>{t('Purchase with')}</p>
                                    <div className='BnrSpnSrIg'>
                                        
                                          {homepagedata?.paymentgateway.slice(0,4).map((rowdata) => (   
                                        <div className='BnrSpnSrIgDts' key={rowdata}>
                                            <img src={rowdata?.paymentimage} alt='' />
                                        </div>
))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3'>
                            <div className="IndvEnty">
                                <div className="MxBnsAvlDts">
                                    <h6>{t('Individual Entries')}</h6>
                                    <h5>{homepagedata?.individual_entries}</h5>
                                </div>
                                <div className="MxBnsAvlDts">
                                    <h6>{t('Total Pre-sale Supply')}</h6>
                                    <h5>{homepagedata?.total_pre_supply} KKOG</h5>
                                </div>
                                <div className="MxBnsAvlDts">
                                    <h6>{t('Acceptable Currency')}</h6>
                                    <h5 className='pb-0'>{secondHalf}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
   
}
TokenSale.propTypes = {
    homepagedata: PropTypes.shape({
        acceptable_currencies: PropTypes.any,
        max_bonus_available: PropTypes.any,
        exchange_rate: PropTypes.any,
        individual_entries: PropTypes.any,
        total_pre_supply: PropTypes.any,
        paymentgateway: PropTypes.arrayOf(
                        PropTypes.shape({
                            paymentimage: PropTypes.any,
                        }))
    }),
    buy: PropTypes.any,

}


export default TokenSale;
